export const getNestedValue = <T>(obj: T, fieldNames: (keyof T | string)[]): any => {
  if (!obj) return undefined

  return fieldNames.reduce((current: any, fieldName: keyof T | string) => {
    if (current && typeof current === 'object' && current[fieldName] !== undefined) {
      return current[fieldName]
    }
    return undefined
  }, obj)
}
